import { Route } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import ProtectedRouteV2 from './ProtectedRouteV2';
import FeatureProtectedRoute from './FeatureProtectedRoute';
import { SYSTEM_FEATURE } from '../types/system/features';

// Pages
import ClientBalancesPage from '../pages/AccountsReceivable/ClientBalancesPage';
import RegisterPaymentCxcPage from '../pages/AccountsReceivable/RegisterPaymentCxcPage';
import PaymentHistoryCxcPage from '../pages/AccountsReceivable/PaymentHistoryCxcPage';
import UpcomingDueCxcPage from '../pages/AccountsReceivable/UpcomingDueCxcPage';
import OverdueCxcPage from '../pages/AccountsReceivable/OverdueCxcPage';
import AgingReportCxcPage from '../pages/AccountsReceivable/AgingReportCxcPage';

const accountsReceivableRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    <Route element={<FeatureProtectedRoute feature={SYSTEM_FEATURE.ACCOUNTS_RECEIVABLE} />}>
    {/* 💸 Clientes con deuda */}
    <Route
      path="/finance/cxc/client-balances"
      element={
        <>
          <PageTitle title="Clientes con Deuda | Codenova POS" />
          <ClientBalancesPage />
        </>
      }
    />

    {/* 💳 Registrar pago de cliente */}
    <Route
      path="/finance/cxc/register-payment/:receivableId?"
      element={
        <>
          <PageTitle title="Registrar Pago Cliente | Codenova POS" />
          <RegisterPaymentCxcPage />
        </>
      }
    />

    {/* 📜 Historial de pagos */}
    <Route
      path="/finance/cxc/payment-history/:receivableId?"
      element={
        <>
          <PageTitle title="Historial de Pagos Cliente | Codenova POS" />
          <PaymentHistoryCxcPage />
        </>
      }
    />

    {/* ⏳ Próximos a vencer */}
    <Route
      path="/finance/cxc/upcoming-due"
      element={
        <>
          <PageTitle title="Próximos a Vencer | Codenova POS" />
          <UpcomingDueCxcPage />
        </>
      }
    />

    {/* ❌ Vencidos */}
    <Route
      path="/finance/cxc/overdue"
      element={
        <>
          <PageTitle title="Cuentas Vencidas | Codenova POS" />
          <OverdueCxcPage />
        </>
      }
    />

    {/* 📊 Aging */}
    <Route
      path="/finance/cxc/aging"
      element={
        <>
          <PageTitle title="Reporte Aging | Codenova POS" />
          <AgingReportCxcPage />
        </>
      }
    />
    </Route>
  </Route>
);

export default accountsReceivableRoutes;
